// src/pages/Messagerie.jsx
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../api";
import Footer from "./Footer";
import UserAvatar from "./UserAvatar";
//import logo from '../images/logo.png';

const Messagerie = ({ currentUserId }) => {
  const { otherId } = useParams();
  const [messages, setMessages] = useState([]);
  const [text, setText] = useState("");
  const [otherUser, setOtherUser] = useState(null);
  const navigate = useNavigate();

  // Charger les messages
  useEffect(() => {
    if (!otherId) return;

    const fetchMessages = async () => {
      try {
        const res = await api.get(`/api/messages/${otherId}`);
        setMessages(res.data);

        if (res.data.length > 0) {
          const msg = res.data[0];
          const user = msg.sender._id === currentUserId ? msg.receiver : msg.sender;
          setOtherUser(user);
        }
      } catch (err) {
        console.error("Erreur chargement messages :", err);
      }
    };

    fetchMessages();
    const interval = setInterval(fetchMessages, 3000);
    return () => clearInterval(interval);
  }, [otherId, currentUserId]);

  // Envoyer un message
  const sendMessage = async () => {
    if (!text.trim() || !otherId) return;
    try {
      const res = await api.post("/api/messages", {
        receiverId: otherId,
        content: text,
      });
      setMessages((prev) => [...prev, res.data.message]);
      setText("");
    } catch (err) {
      console.error("Erreur envoi message :", err);
    }
  };

  return (
    <div className="flex flex-col min-h-screen" style={{ backgroundColor: 'var(--app-background)' }}>
      {/* Header */}
      <header className="bg-white border-b px-4 py-3 flex items-center gap-3 shadow-sm">
        <button
          onClick={() => navigate(-1)}
          className="link-fuchsia text-xl"
          aria-label="Retour"
        >
          ←
        </button>
        { /* <img src={logo} alt="Logo" className="h-8" /> */}
        <h1 className=" w-full text-center text-lg font-semibold text-gray-800">Messagerie</h1>
      </header>

      {/* Chat */}
      <main className="flex-1 px-4 py-6 overflow-y-auto">
        {otherUser ? (
          <div className="max-w-lg mx-auto">
            {/* En-tête conversation */}
            <div className="flex items-center gap-3 mb-6 p-3 bg-white rounded-xl shadow-sm border">
              <UserAvatar
                photo={otherUser.photo}
                name={otherUser.name}
                prenom={otherUser.prenom}
                alt={`${otherUser.prenom || ""} ${otherUser.name || ""}`.trim()}
                className="w-10 h-10 border"
              />
              <div>
                <p className="font-semibold text-gray-800">
                  {otherUser.name} {otherUser.prenom}
                </p>
                <div className="flex items-center gap-1 text-xs text-[var(--status-success)]">
                  <div className="w-2 h-2 bg-[var(--status-success)] rounded-full"></div>
                  En ligne
                </div>
              </div>
            </div>

            {/* Messages */}
            <div className="space-y-3 mb-2">
              {messages.length === 0 ? (
                <p className="text-center text-gray-500 text-sm py-4 bg-white rounded-xl">
                  Aucun message pour l’instant
                </p>
              ) : (
                messages.map((msg, i) => {
                  const isMe = msg.sender._id === currentUserId;
                  const sender = msg.sender;

                  return (
                    <div
                      key={i}
                      className={`flex items-start gap-2 ${
                        isMe ? "justify-end" : "justify-start"
                      }`}
                    >
                      {/* Photo (uniquement pour l'autre utilisateur) */}
                      {!isMe && (
                        <UserAvatar
                          photo={sender.photo ? `https://backend-qybe.onrender.com${sender.photo}` : null}
                          name={sender.name}
                          prenom={sender.prenom}
                          className="w-8 h-8"
                        />
                      )}

                      {/* Bulle de message - TOUS EN BLANC */}
                      <div
                        className={`px-4 py-2 rounded-2xl text-sm max-w-xs ${
                          isMe
                            ? "bg-white text-gray-800 rounded-tr-none shadow border-l-4 border-[var(--accent-primary)]"
                            : "bg-white text-gray-800 rounded-tl-none shadow"
                        }`}
                      >
                        <p>{msg.content}</p>
                        <p
                          className={`text-xs mt-1 text-right ${
                            isMe ? "text-gray-500" : "text-gray-500"
                          }`}
                        >
                          {new Date(msg.createdAt).toLocaleTimeString("fr-FR", {
                            hour: "2-digit",
                            minute: "2-digit",
                          })}
                        </p>
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          </div>
        ) : (
          <p className="text-center text-gray-500">Chargement...</p>
        )}
      </main>

      {/* Barre d'envoi */}
      {otherUser && (
        <div className="bg-white border-t p-3">
          <div className="max-w-lg mx-auto flex items-center gap-2">
            <button
              className="link-accent"
              aria-label="Joindre un fichier"
            >
              📎
            </button>
            <input
              type="text"
              value={text}
              onChange={(e) => setText(e.target.value)}
              onKeyPress={(e) => e.key === "Enter" && sendMessage()}
              placeholder="Écrire un message..."
              className="flex-1 border border-gray-300 rounded-full px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[var(--accent-primary)]"
            />
            <button
              onClick={sendMessage}
              className="btn-primary rounded-full p-2"
              aria-label="Envoyer"
            >
              ➤
            </button>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default Messagerie;
